<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <!-- <div class="advancedSearch">
                <button type="button" mat-raised-button>
                    <span><mat-icon svgIcon="filter"></mat-icon></span>
                    <span>Advanced Search</span> 
                </button>
            </div> -->

            <div class="advancedSearch">
                <mat-form-field floatLabel='never'>
                    <input type="text" name="serach" id="serach" autocomplete="off" matInput placeholder="Search" [formControl]="advanceSearchCtrl">
                    <mat-icon svgIcon="filter" matPrefix></mat-icon>
                </mat-form-field>
            </div>

        </div>
        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group">
                <button type="button" class="btn-int-blue" (click)="createUser()" mat-raised-button>Create User</button>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <!-- <div class="mat-table-responsive" *ngIf="usersDataSource?.data?.length; else noRecord"> -->
            <div class="mat-table-responsive">
                <table mat-table [dataSource]="usersDataSource" matSort>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let element">
                            <a class="forUserName" (click)="updateUser(element?.id)">{{element?.name}}</a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email ID</th>
                        <td mat-cell *matCellDef="let element"> {{element?.email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="org_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Organization</th>
                        <td mat-cell *matCellDef="let element"> {{element?.org_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                        <td mat-cell *matCellDef="let element">
                            {{(element?.role?.length > 0 )?(element?.role[0]?.role_name):"-"}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-slide-toggle 
                                [checked]="!element?.status" 
                                (change)="toggleStatus(element)">
                            </mat-slide-toggle>
                        </td>
                    </ng-container>                   
                    <tr mat-header-row *matHeaderRowDef="usersDisplayedColumns | tableShowColumns; sticky: true;"></tr>
                    <tr mat-row *matRowDef="let row; columns: usersDisplayedColumns | tableShowColumns;"></tr>
                </table>
                <ng-container *ngIf="usersDataSource?.filteredData?.length == 0">
                    <div class="row forNoRecords">
                        <h3 class="table-no-date"> No Record found</h3>
                    </div>
                </ng-container>
                <app-table-loader></app-table-loader>

            </div>
            <!-- <ng-template #noRecord>
                <div class="table-no-date">
                    No Record found
                </div>
            </ng-template> -->
        </div>
    </div>
</div>